import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '@bcef/ia-components/loader';
import { ContextService, getClassNames } from '@bcef/ia-shared';
import { DataLayer } from '@difa/ia-data-layer';
import { TranslateService } from '@ngx-translate/core';
import clsx from 'clsx';

import { sponsorshipStore } from '@features/parrainage-filleul/store/sponsorship.store';
import { HeaderComponent } from '@shared/components/header/header.component';

@Component({
  selector: 'ia-parrainage-filleul-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [RouterOutlet, HeaderComponent, LoaderComponent],
})
export class AppComponent {
  private readonly translate = inject(TranslateService);

  private readonly contextService = inject(ContextService);

  protected readonly store = inject(sponsorshipStore);

  protected readonly isLoading = computed(() => this.store.sponsorshipLoadingStatus().isLoading);

  protected readonly isMbGroup = this.contextService.isMbGroup;

  private readonly _datalayer = inject(DataLayer);

  protected typologies: string;

  constructor() {
    this.translate.use(this.contextService.language);
    this.typologies = clsx(getClassNames(this.contextService.typology));
  }
}
